jQuery( document ).ready( function ( $ ) {

	let parentBlock, parentSection;
	let fixedBlock;
	let advertisingContentItem;
	let allListItems = document.querySelectorAll('.nav-list-item');
	let sections = document.querySelectorAll( '.advertising' );
	let navItem;

	const options = {
		root: null,
		threshold: 0,
		rootMargin: '-10% 0px -85% 0px',
	};


	const callback = function ( entries, observer ) {
		entries.forEach( entry => {
			if ( entry.isIntersecting ) {
				$( navItem ).each( function ( i, elem ) {
					deleteActive( elem );
				} )
				if ($(entry.target).parent('.current-section')) {
					let currEntryTarget = entry.target;
					let dataId = currEntryTarget.getAttribute( 'data-id' );
					let activeNavItem = $(parentSection).find( `*[data-nav='${dataId}']` );
					$( activeNavItem ).addClass( 'active' );
				}
			}
		} );
	};

	const options2 = {
		root: null,
		threshold: 0,
		rootMargin: '-10% 0px -85% 0px',
	};


	const callback2 = function ( entries, observer ) {
		entries.forEach( entry => {
			if ( entry.isIntersecting ) {
				parentSection = entry.target;
				entry.target.classList.add('current-section');
			} else {
				if (entry.target.classList.contains('current-section')) {
					entry.target.classList.remove('current-section');
				}
			}
		} );
	};

	advertisingContentItem = document.querySelectorAll( `.advertising__list-item` );
	navItem = $( `.nav-list-item`);
	const observer = new IntersectionObserver( callback, options );
	advertisingContentItem.forEach( listItem => {
		observer.observe( listItem );
	} )
	const observer2 = new IntersectionObserver( callback2, options2 );
	sections.forEach( listItem => {
		observer2.observe( listItem );
	} )

	function currentItem(currentFocusItem) {
		let current = document.querySelector(currentFocusItem);
		if (current && $(current).parents('.advertising')) {
			let parentSection = $(current).parents('.advertising');

			$( navItem ).each( function ( i, elem ) {
				if ($(elem).parents(parentSection)) {
					deleteActive( elem );
				}
			} )
			parentSection.find(current).find('.nav-list-item').addClass('active');

			if ( parentSection.find(current).find('.nav-list-item').hasClass( 'active' ) ) {
				let tab_id = parentSection.find(current).find('.nav-list-item').attr( 'data-nav' );
				let currentListItem = parentSection.find( `*[data-id='${tab_id}']` );

				let topPosition = $( currentListItem ).offset().top - 80;
				window.scroll( {
					top: topPosition,
					behavior: 'smooth'
				} );

			}
		}
	}

	$( navItem ).on( 'click', function ( e ) {

		const current = e.target;

		let parentSection = $(current).parents('.advertising');
		$( navItem ).each( function ( i, elem ) {
			if ($(elem).parents(parentSection)) {
				deleteActive( elem );
			}
		} )
		parentSection.find(current).addClass('active');

		if ( parentSection.find(current).hasClass( 'active' ) ) {
			let tab_id = parentSection.find(current).attr( 'data-nav' );
			let currentListItem = parentSection.find( `*[data-id='${tab_id}']` );
			$( currentListItem )[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	} );

	function deleteActive( element ) {
		if ( $( element ).hasClass( 'active' ) ) {
			$( element ).removeClass( 'active' );
		}
	}

	document.addEventListener('keyup', function(e) {
		if (e.code == 'Tab') {
			currentItem('.keyboard-focus');
		}
	});

} );